import React from "react";

// Customizable Area Start
import { IconButton, Switch, Box, Grid, Typography, TextField, Button, FormControl, FormLabel } from "@mui/material";
import { logo, searchIcon } from "./assets";
import 'react-datepicker/dist/react-datepicker.css';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NavigationMenu from "../../navigationmenu/src/NavigationMenu.web";
import ShareIcon from "@mui/icons-material/Share";
import { styled } from '@mui/material/styles';

const StyledButton = styled(Button)({
  textTransform: 'capitalize',
});
// Customizable Area End

import CustomisableUserProfilesScreenController, {
  Props,
} from "./CustomisableUserProfilesScreenController";

const industries = [
  "Agriculture",
  "Automotive",
  "Education",
  "Computers & Electronics",
  "Consumer Goods",
  "Financial Services",
  "Government",
  "Gaming",
  "Hospitality",
  "Healthcare",
  "Life Sciences"
];

export default class CustomisableUserProfilesScreen extends CustomisableUserProfilesScreenController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }
  // Customizable Area Start
  // Customizable Area End

  render() {
    return (
      // Customizable Area Start
      <Box sx={{ minHeight: '100vh', height: '100%', display: 'flex', width: '100%', overflowX: 'hidden' }}>
        {/* Sidebar */}
        <Box sx={{ minHeight: '100vh', flexGrow: 0, width: '115px', borderRight: '1px solid #cbd5e1', height: '100%', backgroundColor: '#ffffff', }}>
          <NavigationMenu id={""} navigation={""} />
        </Box>

        {/* Main Content */}
        <Box sx={{ padding: 2, flexGrow: 1, height: '100%', width: '100%', minHeight: '100vh', }}>
          <Box sx={{ margin: '22px', }}>
            <img
              onClick={(e) => {
                e.stopPropagation()
                this.props.navigation.navigate("LandingPage")
              }}
              style={{ height: '24px', width: '148px', cursor: "pointer" }}
              alt="Logo"
              src={logo}
            />
          </Box>
          <Box sx={{
            minHeight: 'calc(100vh - 64px)',
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            padding: "32px",
            margin: "32px",
            borderTop: "1px solid #cbd5e1",
            borderTopRightRadius: "8px",
            borderTopLeftRadius: "8px",
            borderLeft: "1px solid #cbd5e1",
            borderRight: "1px solid #cbd5e1",
          }}>
            <Typography textAlign="left"
              sx={{ zIndex: 1, display: 'flex', fontFamily: "Inter", alignItems: 'center', fontWeight: "700", letterSpacing: "0%", marginBottom: '60px', fontSize: "14px", lineHeight: "22px", }}
            >
              {/* Added back icon */}
              <Box sx={{ mr: 1 }}>
                <ArrowBackIcon
                  data-test-id = "ArrowBackIcon"
                  sx={{ cursor: "pointer" }}
                  onClick={() => this.handleBackClick()} />
              </Box>
              Company and Job Title
            </Typography>
            <Grid container spacing={10} sx={{ flexGrow: 1, px: 4 }}>
              {/* Left Column for first two grids of first row and first two grids of second row */}
              <Grid item md={8} xs={12}>
                <Grid container spacing={10}>
                  {/* First Row: First two grids */}
                  <Grid item md={6} xs={12} sx={{ alignSelf: 'flex-start', height: 'auto' }}>
                    {/* First Grid Content: Company/Organization */}
                    <FormControl fullWidth>
                      <FormLabel sx={{ color: 'black', fontWeight: 'bold', mb: 2 }}>
                        Company/Organisation<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                      </FormLabel>
                      <TextField
                        data-test-id="company_input"
                        value={this.state.company}
                        onChange={(e) => this.handleCompanyChange(e)}
                        placeholder="Enter Company Name"
                        error={!!this.state.companyError}
                        helperText={this.state.companyError}
                        fullWidth
                        required
                        InputProps={{
                          style: { borderRadius: '8px' },
                          sx: {
                            height: '50px',
                            width: '100%'
                          }
                        }}
                        FormHelperTextProps={{ style: { marginLeft: '-1px' } }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item md={6} xs={12} sx={{ alignSelf: 'flex-start', height: 'auto' }}>
                    {/* Second Grid Content: Job Title */}
                    <FormControl fullWidth>
                      <FormLabel sx={{ color: 'black', fontWeight: 'bold', mb: 2 }}>
                        Job Title<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                      </FormLabel>
                      <TextField
                        data-test-id="job_title_input"
                        value={this.state.jobTitle}
                        onChange={(e) => this.handleJobTitleChange(e)}
                        placeholder="Select your job title"
                        fullWidth
                        required
                        InputProps={{
                          style: { borderRadius: '8px' },
                          sx: {
                            height: '50px',
                            width: '100%'
                          }
                        }}
                      />
                    </FormControl>
                  </Grid>
                  {/* Second Row: First two grids */}
                  <Grid item md={6} xs={12} sx={{ alignItems: 'flex-start' }}>
                    {/* Fourth Grid Content: Choose industries you work in */}
                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: 'auto', boxSizing: 'border-box' }}>
                      <div style={{ fontFamily: 'Inter', fontWeight: 700, fontSize: '14px', lineHeight: '22px', color: '#000000', marginBottom: '10px' }}>
                        Choose the industries you work in<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                        <img src={searchIcon} alt="search icon" style={{ width: '17.05px', height: '17.06px', marginRight: '6px' }} />
                        <input
                          data-test-id = "industrysearch_work_button"
                          style={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '14px', lineHeight: '22px', color: '#94a3b8', border: 'none', outline: 'none', background: 'transparent', width: '100%' }}
                          placeholder="Search your industries"
                          required
                          value={this.state.searchIndustriesYouWorkIn}
                          onChange={(e) => this.handleSearchIndustriesYouWorkInChange(e.target.value)}
                        />
                      </div>
                      <div style={{ width: '100%', height: '1px', backgroundColor: '#94A3B8', marginBottom: '20px', opacity: '60%' }} />
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                        {industries
                          .filter(industry =>
                            this.state.searchIndustriesYouWorkIn === "" ||
                            industry.toLowerCase().includes(this.state.searchIndustriesYouWorkIn.toLowerCase())
                          )
                          .map((industry) => (
                            <div
                              data-test-id="industry_work_button"
                              key={industry}
                              style={{ padding: '14px 16px', background: this.state.industriesYouWorkIn.includes(industry) ? '#BBCF8D' : 'rgba(100, 94, 112, 0.07)', borderRadius: '10px', border: '1px solid #645e7033', color: '#645e70', fontFamily: 'Inter', fontWeight: 700, fontSize: '12px', lineHeight: '18px', textAlign: 'center', width: 'auto', cursor: 'pointer' }}
                              onClick={() => this.handleIndustriesYouWorkInSelect(industry)}
                            >
                              {industry}
                            </div>
                          ))}
                      </div>
                    </div>
                  </Grid>
                  <Grid item md={6} xs={12} sx={{ alignItems: 'flex-start' }}>
                    {/* Fifth Grid Content: Second Industries of Interest */}
                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: 'auto', boxSizing: 'border-box' }}>
                      <div style={{ fontSize: '14px', lineHeight: '22px', color: '#000000', fontFamily: 'Inter', fontWeight: 700, marginBottom: '4px' }}>
                        Industries of Interest<span style={{ marginLeft: '4px', color: 'red' }}>*</span>
                      </div>
                      <div style={{ fontFamily: 'Inter', fontSize: '12px', lineHeight: '16px', fontWeight: 500, fontStyle: 'italic', marginBottom: '10px', color: '#747474' }}>
                        Choose the industries whose profiles you would be interested in
                      </div>
                      <div style={{ alignItems: 'center', marginBottom: '20px', display: 'flex' }}>
                        <img alt="search icon" src={searchIcon} style={{ height: '17.06px', marginRight: '6px', width: '17.05px' }} />
                        <input
                          data-test-id = "industrysearch_interest2_button"
                          style={{ fontFamily: 'Inter', fontSize: '14px', lineHeight: '22px', color: '#94a3b8', fontWeight: 400, outline: 'none', background: 'transparent', border: 'none', width: '100%' }}
                          required
                          placeholder="Search your industries of interest"
                          value={this.state.searchIndustriesOfInterest2}
                          onChange={(e) => this.handleSearchIndustriesOfInterest2Change(e.target.value)}
                        />
                      </div>
                      <div style={{ height: '1px', backgroundColor: '#94A3B8', display: 'inline-block', width: '100%', marginBottom: '20px', opacity: '60%' }} />
                      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {industries
                          .filter(industry =>
                            this.state.searchIndustriesOfInterest2 === "" ||
                            industry.toLowerCase().includes(this.state.searchIndustriesOfInterest2.toLowerCase())
                          )
                          .map((industry) => (
                            <div
                              data-test-id="industry_interest2_button"
                              key={industry}
                              style={{ fontFamily: 'Inter', background: this.state.industriesOfInterest2.includes(industry) ? '#BBCF8D' : 'rgba(100, 94, 112, 0.07)', borderRadius: '10px', border: '1px solid #645e7033', color: '#645e70', width: 'auto', fontWeight: 700, padding: '14px 16px', fontSize: '12px', lineHeight: '18px', textAlign: 'center', cursor: 'pointer' }}
                              onClick={() => this.handleIndustriesOfInterest2Select(industry)}
                            >
                              {industry}
                            </div>
                          ))}
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              {/* Right Column for third grid of first row */}
              <Grid item md={4} xs={12}>
                <Grid container spacing={10}>
                  {/* Third Grid Content: Industries of Interest */}
                  <Grid item md={12} xs={12}>
                    <div style={{ boxSizing: 'border-box', display: 'flex', flexDirection: 'column', width: '100%', height: 'auto' }}>
                      <div style={{ lineHeight: '22px', color: '#000000', marginBottom: '4px', fontFamily: 'Inter', fontWeight: 700, fontSize: '14px' }}>
                        Industries of Interest<span style={{ marginLeft: '4px', color: 'red' }}>*</span>
                      </div>
                      <div style={{ fontWeight: 500, fontFamily: 'Inter', color: '#747474', fontStyle: 'italic', marginBottom: '10px', fontSize: '12px', lineHeight: '16px' }}>
                        Choose the industries whose profiles you would be interested in
                      </div>
                      <div style={{ display: 'flex', marginBottom: '20px', alignItems: 'center' }}>
                        <img alt="search icon" src={searchIcon} style={{ height: '17.06px', marginRight: '6px', width: '17.05px' }} />
                        <input
                          data-test-id = "industrysearch_interest_button"
                          style={{ outline: 'none', background: 'transparent', fontFamily: 'Inter', fontWeight: 400, color: '#94a3b8', border: 'none', width: '100%', fontSize: '14px', lineHeight: '22px' }}
                          required
                          placeholder="Search your industries of interest"
                          value={this.state.searchIndustriesOfInterest1}
                          onChange={(e) => this.handleSearchIndustriesOfInterest1Change(e.target.value)}
                        />
                      </div>
                      <div style={{ display: 'inline-block', width: '100%', height: '1px', backgroundColor: '#94A3B8', marginBottom: '20px', opacity: '60%' }} />
                      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {industries
                          .filter(industry =>
                            this.state.searchIndustriesOfInterest1 === "" ||
                            industry.toLowerCase().includes(this.state.searchIndustriesOfInterest1.toLowerCase())
                          )
                          .map((industry) => (
                            <div
                              data-test-id="industry_interest_button"
                              key={industry}
                              style={{ fontFamily: 'Inter', fontWeight: 700, fontSize: '12px', background: this.state.industriesOfInterest1.includes(industry) ? '#BBCF8D' : 'rgba(100, 94, 112, 0.07)', borderRadius: '10px', border: '1px solid #645e7033', color: '#645e70', lineHeight: '18px', textAlign: 'center', padding: '14px 16px', width: 'auto', cursor: 'pointer' }}
                              onClick={() => this.handleIndustrySelect(industry)}
                            >
                              {industry}
                            </div>
                          ))}
                      </div>
                    </div>
                  </Grid>
                  {/* Preview VBC Section */}
                  <Grid item md={12} xs={12}>
                    <div style={{ width: "100%", padding: "10px 0" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "11px", flex: 1 }}>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <span style={{ fontFamily: "Inter", fontSize: "14px", fontWeight: 700, lineHeight: "22px", color: "#000000", letterSpacing: "0%" }}>Your Virtual Business Card (VBC)</span>
                            <span style={{ color: "#FF0000", marginLeft: "2px" }}>*</span>
                          </div>
                          <p style={{ fontFamily: "Inter", fontSize: "12px", fontWeight: 500, lineHeight: "16px", color: "#747474", margin: 0, maxWidth: "253px", letterSpacing: "0%" }}>
                            Allow Matched Users to Share Your VBCs to their Connections in the App
                          </p>
                        </div>
                        <div style={{ width: "33px", height: "68px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                          <IconButton style={{ cursor: "pointer", backgroundColor: "#BBCF8D", width: "30px", height: "30px", marginBottom: "20px" }}>
                            <ShareIcon style={{ color: "#000000" }} />
                          </IconButton>
                          <Switch
                           data-test-id="vbc_toggle"
                            value={this.state.vbcToggle}
                            onChange={() => this.setState({ vbcToggle: !this.state.vbcToggle })}
                            required
                            sx={{
                              width: '33px',
                              height: '19px',
                              padding: 0,
                              '& .MuiSwitch-track': {
                                width: '33px',
                                height: '19px',
                                borderRadius: '10px',
                                backgroundColor: '#CCCCCC',
                                opacity: 1,
                                borderWidth: '1px',
                                borderColor: '#CCCCCC',
                                transition: 'background-color 300ms, border-color 300ms',
                              },
                              '& .MuiSwitch-thumb': {
                                marginTop: '-5px',
                                marginLeft: '-5px',
                                width: '11px',
                                height: '11px',
                                borderRadius: '50%',
                                backgroundColor: '#FFFFFF',
                                boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
                                transition: 'transform 300ms',
                              },
                              '&.Mui-checked .MuiSwitch-track': {
                                backgroundColor: '#65DD65',
                                borderColor: '#65DD65',
                              },
                              '&.Mui-checked .MuiSwitch-thumb': {
                                transform: 'translateX(17px)',
                              },
                            }}
                          />
                        </div>
                      </div>
                      <div style={{ fontFamily: "Inter", fontSize: "14px", fontWeight: 700, lineHeight: "16px", letterSpacing: "0%", textAlign: "center", color: "#645E70", marginTop: "30px", textTransform: 'capitalize', cursor: 'pointer' }}>
                        <u>Preview your VBC</u>
                      </div>
                    </div>
                  </Grid>
                  {/* Submit Button */}
                  <Grid item md={12} xs={12} sx={{ display: 'flex', justifyContent: "center", alignItems: "center", mt: 2 }}>
                    <StyledButton
                      data-test-id="submit_button"
                      variant="contained"
                      disabled={!(this.state.company && this.state.jobTitle &&
                        this.state.industriesOfInterest1.length > 0 &&
                        this.state.industriesOfInterest2.length > 0 &&
                        this.state.industriesYouWorkIn.length > 0 &&
                        this.state.vbcToggle)}
                      sx={{
                        width: '75%',
                        height: '50px',
                        borderRadius: '8px',
                        fontFamily: 'Inter',
                        fontWeight: 700,
                        fontSize: '16px',
                        lineHeight: '24px',
                        paragraphSpacing: '8px',
                        letterSpacing: '0%',
                        backgroundColor: !(this.props as any).disabled ? 'black' : '#default-color',
                        '&:hover': {
                          backgroundColor: !(this.props as any).disabled ? 'black' : '#default-color',
                        },
                      }}
                    >
                      Submit
                    </StyledButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
      // Customizable Area End
    );
  }
}

// Customizable Area Start

// Customizable Area End